export const palette = {
  1: '#9999FF',
  2: '#6B7DB3',
  3: '#3655B3',
  4: '#A6BCFF',
  5: '#6545A4',
  6: '#CEB5FF',
  7: '#CDA5F3',
}
